var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63208 7.42082V10.3688H3.36888V14.7889H2.63208V16.9993H14.4209L16.6313 17V16.9993H17.3681V14.7889H16.6313V10.3688H17.3681V7.42082L10.0001 3L2.63208 7.42082ZM5.57929 14.7889V10.3688H7.0529V14.7889H5.57929ZM9.26331 14.7889V10.3688H10.7369V14.7889H9.26331ZM14.4209 14.7889H12.9473V10.3688H14.4209V14.7889ZM11.4737 7.42082C11.4737 7.61439 11.4355 7.80605 11.3614 7.98486C11.2873 8.16367 11.1786 8.32613 11.0417 8.46297C10.9048 8.59981 10.7423 8.70834 10.5635 8.78237C10.3846 8.8564 10.1929 8.89447 9.99938 8.89443C9.80581 8.89438 9.61415 8.8562 9.43534 8.78209C9.25653 8.70797 9.09406 8.59935 8.95723 8.46245C8.82039 8.32554 8.71186 8.16303 8.63783 7.98418C8.5638 7.80533 8.52572 7.61365 8.52577 7.42008C8.52587 7.02916 8.68126 6.65429 8.95775 6.37793C9.23424 6.10158 9.60919 5.94638 10.0001 5.94648C10.391 5.94657 10.7659 6.10196 11.0423 6.37845C11.3186 6.65495 11.4738 7.0299 11.4737 7.42082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank);
export default __webpack_public_path__ + "static/media/icon_bank.3e1e84c15b9f2500dca6ce162351495e.svg";
export { ForwardRef as ReactComponent };